import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, []);
  const undoInvoiceCancel = `undoInvoiceCancel(input: ${dataModify})`;
  return gql`
  mutation {
    ${undoInvoiceCancel} {
      id
    }
  }
`;
};
